import { createFileRoute, notFound } from "@tanstack/react-router";

import { PluginDetailPage } from "../components/plugins/PluginDetailPage";
import { isForgePluginId } from "../components/plugins/pluginsPage.logic";

export const Route = createFileRoute("/_chat/plugins/$pluginId")({
  component: PluginDetailRouteView,
});

function PluginDetailRouteView() {
  const { pluginId } = Route.useParams();

  if (!isForgePluginId(pluginId)) {
    throw notFound();
  }

  return <PluginDetailPage pluginId={pluginId} />;
}
